import React, { useState } from "react";
import "./MixedLayerDropdown.css";
import CircularProgress from "@mui/material/CircularProgress";
import LayerInfoIcon from "../../atoms/layerInfoIcon/LayerInfoIcon";

const MixedLayerDropdown = ({
  title,
  description,
  subcategories,
  items,
  opacities,
  onHandleOpacity,
  iconClass,
  panelType,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [openSubcategory, setOpenSubcategory] = useState(null);
  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleSubcategoryToggle = (index) => {
    setOpenSubcategory(openSubcategory === index ? null : index);
  };

  return (
    <div
      className="dropdown-container"
      data-testid={`${panelType}-dropdown-${title}`}
    >
      <div className="dropdown-header-row">
        <button
          className={`dropdown-toggle-layers ${isOpen ? "openDrag" : ""}`}
          onClick={handleToggle}
          data-testid={`${panelType}-dropdown-toggle-${title}`}
        >
          {iconClass &&
            (typeof iconClass === "string" ? (
              <i
                className={iconClass}
                style={{ fontSize: "16px", marginRight: "8px" }}
              />
            ) : React.isValidElement(iconClass) ? (
              React.cloneElement(iconClass, {
                style: { fontSize: "16px", marginRight: "8px" },
              })
            ) : null)}
          {title}
        </button>
        <LayerInfoIcon
          description={description}
          testId={`${panelType}-dropdown-${title}`}
        />
      </div>
      {isOpen && items.length > 0 && (
        <div
          className="direct-items"
          data-testid={`${panelType}-direct-items-${title}`}
        >
          {items.map((item, index) => (
            <div
              key={index}
              data-testid={`${panelType}-layer-row-${item.name}`}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "3px 15px",
              }}
            >
              <div
                className={`dropdown-content-item ${
                  item.disabled ? "dropdown-content-item-disabled" : ""
                }`}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "3px",
                }}
              >
                <input
                  type="checkbox"
                  data-testid={`${panelType}-layer-checkbox-${item.name}`}
                  className="custom-checkbox"
                  value={item.name}
                  name={item.name}
                  checked={item.showItem}
                  disabled={item.disabled}
                  onChange={(e) => {
                    if (item.disabled) return;
                    item.onChange(e);
                  }}
                />
                <div
                  data-testid={`${panelType}-layer-label-${item.name}`}
                  onClick={() => {
                    if (item.disabled) return;
                    item.onChange({
                      target: { checked: !item.showItem, value: item.name },
                    });
                  }}
                  style={{
                    cursor: item.disabled ? "not-allowed" : "pointer",
                  }}
                >
                  {item.title}
                </div>
                {/* Show loading spinner */}
                {item.isLoading && <CircularProgress size={18} />}
              </div>

              {/* Conditionally render opacity slider only for non-3D items */}
              {item.name !== "3D" &&
                item.name !== "Carroyage DFCI" &&
                item.name !== "windDirection" &&
                item.name !== "majorRoads" &&
                item.name !== "railways" &&
                item.name !== "fireStations" &&
                item.name !== "arttificiel-water" &&
                item.name !== "Régions" &&
                item.name !== "Départements" && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <input
                      type="range"
                      data-testid={`${panelType}-layer-opacity-slider-${item.name}`}
                      min="1"
                      max="100"
                      value={opacities[item.name] || 100}
                      onMouseDown={(e) => e.stopPropagation()} // Prevent closing the dropdown
                      onChange={(e) =>
                        onHandleOpacity(item.name, Number(e.target.value))
                      }
                    />
                    <label
                      data-testid={`${panelType}-layer-opacity-value-${item.name}`}
                    >
                      {opacities[item.name] || 100}%
                    </label>
                  </div>
                )}
            </div>
          ))}
        </div>
      )}
      <div
        className={`dropdown-content ${isOpen ? "open" : ""}`}
        data-testid={`${panelType}-dropdown-content-${title}`}
      >
        {subcategories.map((subcategory, subIndex) => (
          <div
            key={subIndex}
            data-testid={`${panelType}-subcategory-${subcategory.name}`}
          >
            <button
              data-testid={`${panelType}-subcategory-toggle-${subcategory.name}`}
              className={`sub-dropdown-toggle ${
                openSubcategory === subIndex ? "openDragSub" : ""
              }`}
              onClick={() => handleSubcategoryToggle(subIndex)}
            >
              {subcategory.title}
            </button>
            <div
              data-testid={`${panelType}-subcategory-content-${subcategory.name}`}
              className={`dropdown-content ${
                openSubcategory === subIndex ? "open" : ""
              }`}
            >
              {subcategory.items.map((item, index) => (
                <div
                  key={index}
                  data-testid={`${panelType}-layer-row-${item.name}`}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "3px 18px",
                  }}
                >
                  <div
                    className={`dropdown-content-item ${
                      item.disabled ? "dropdown-content-item-disabled" : ""
                    }`}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "3px",
                    }}
                  >
                    <input
                      type="checkbox"
                      data-testid={`${panelType}-layer-checkbox-${item.name}`}
                      className="custom-checkbox"
                      value={item.name}
                      name={item.name}
                      checked={item.showItem}
                      disabled={item.disabled}
                      onChange={(e) => {
                        if (item.disabled) return;
                        item.onChange(e);
                      }}
                    />
                    <div
                      data-testid={`${panelType}-layer-label-${item.name}`}
                      onClick={() => {
                        if (item.disabled) return;
                        item.onChange({
                          target: { checked: !item.showItem, value: item.name },
                        });
                      }}
                      style={{
                        cursor: item.disabled ? "not-allowed" : "pointer",
                      }}
                    >
                      {item.title}
                    </div>
                    {item.isLoading && <CircularProgress size={18} />}
                  </div>
                  {item.name !== "3D" &&
                    item.name !== "electricalLines" &&
                    item.name !== "electricalStations" &&
                    item.name !== "gazRefuelingStations" &&
                    item.name !== "gazLines" && (
                      <div
                        className="dropdown-opacity-slider"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <input
                          type="range"
                          min="1"
                          max="100"
                          data-testid={`${panelType}-layer-opacity-slider-${item.name}`}
                          value={opacities[item.name] || 100}
                          disabled={item.disabled}
                          className={
                            item.disabled ? "opacity-slider-disabled" : ""
                          }
                          onMouseDown={(e) => e.stopPropagation()}
                          onChange={(e) =>
                            onHandleOpacity(item.name, Number(e.target.value))
                          }
                        />
                        <label
                          data-testid={`${panelType}-layer-opacity-value-${item.name}`}
                        >
                          {opacities[item.name] || 100}%
                        </label>
                      </div>
                    )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default React.memo(MixedLayerDropdown);
